interface MediaGalleryProps {
  media: string[];
  className?: string;
}

export const MediaGallery = ({ media, className = "" }: MediaGalleryProps) => {
  return (
    <div className={`mb-4 ${className}`}>
      <span className="text-sm font-medium mb-2 block">Media</span>
      {!media || media.length === 0 ? (
        <div className="text-sm text-gray-500 italic">
          No media uploaded
        </div>
      ) : (
        <div className="flex gap-2 flex-wrap">
          {media.map((item, index) => (
            <img
              key={index}
              src={item}
              alt={`Media ${index + 1}`}
              className="w-20 h-20 object-cover rounded-xl flex-shrink-0"
            />
          ))}
        </div>
      )}
    </div>
  );
};
